export const DRAW_MODAL_WIDTH = 1520
export const DRAW_PANEL_WIDTH = 240
export const DRAW_GAP = 16
export const DRAW_BODY_PADDING_X = 24
export const DRAW_CANVAS_HEIGHT = 498

export const MARKER_ICON_WIDTH = 48
export const MARKER_LABEL_HEIGHT = 32
export const MARKER_LABEL_MIN_WIDTH = 80
export const MARKER_LABEL_MAX_WIDTH = 464
export const MARKER_LABEL_PADDING_X = 16
export const MARKER_LABEL_MARGIN_BOTTOM = 2
export const MARKER_LABEL_FONT_SIZE = 15
export const MARKER_LABEL_TEXT_OFFSET_Y = 3
export const REGION_LABEL_FONT_SIZE = 15

export function getDrawCanvasWidth () {
  return DRAW_MODAL_WIDTH - DRAW_BODY_PADDING_X * 2 - DRAW_PANEL_WIDTH - DRAW_GAP
}

export function calcObjectFitContainBounds (containerWidth, containerHeight, naturalWidth, naturalHeight) {
  if (!containerWidth || !containerHeight || !naturalWidth || !naturalHeight) {
    return null
  }
  const imgRatio = naturalWidth / naturalHeight
  const containerRatio = containerWidth / containerHeight
  let displayW
  let displayH
  let offsetX
  let offsetY

  if (imgRatio > containerRatio) {
    displayW = containerWidth
    displayH = containerWidth / imgRatio
    offsetX = 0
    offsetY = (containerHeight - displayH) / 2
  } else {
    displayH = containerHeight
    displayW = containerHeight * imgRatio
    offsetX = (containerWidth - displayW) / 2
    offsetY = 0
  }

  return {
    displayW,
    displayH,
    offsetX,
    offsetY,
    containerW: containerWidth,
    containerH: containerHeight
  }
}

export function getOverlayScale (previewBounds, naturalWidth, naturalHeight) {
  if (!previewBounds || !naturalWidth || !naturalHeight) return 1
  const modalBounds = calcObjectFitContainBounds(
    getDrawCanvasWidth(),
    DRAW_CANVAS_HEIGHT,
    naturalWidth,
    naturalHeight
  )
  if (!modalBounds?.displayW || !modalBounds?.displayH) return 1
  const scaleW = previewBounds.displayW / modalBounds.displayW
  const scaleH = previewBounds.displayH / modalBounds.displayH
  return (scaleW + scaleH) / 2
}

export function getImageBoundsFromElements (wrapEl, imgEl) {
  if (!wrapEl || !imgEl) return null
  return calcObjectFitContainBounds(
    wrapEl.clientWidth,
    wrapEl.clientHeight,
    imgEl.naturalWidth,
    imgEl.naturalHeight
  )
}

export function getImageStageStyle (bounds) {
  if (!bounds) return { visibility: 'hidden' }
  return {
    left: `${bounds.offsetX}px`,
    top: `${bounds.offsetY}px`,
    width: `${bounds.displayW}px`,
    height: `${bounds.displayH}px`
  }
}

export function getRelativePointInImage (event, wrapEl, bounds) {
  if (!wrapEl || !bounds) return null
  const wrapRect = wrapEl.getBoundingClientRect()
  const localX = event.clientX - wrapRect.left - bounds.offsetX
  const localY = event.clientY - wrapRect.top - bounds.offsetY

  if (localX < 0 || localY < 0 || localX > bounds.displayW || localY > bounds.displayH) {
    return null
  }

  return {
    x: localX / bounds.displayW,
    y: localY / bounds.displayH
  }
}

export function getScaledMarkerStyles (scale) {
  const s = scale || 1
  return {
    icon: {
      width: `${MARKER_ICON_WIDTH * s}px`
    },
    label: {
      height: `${MARKER_LABEL_HEIGHT * s}px`,
      minWidth: `${MARKER_LABEL_MIN_WIDTH * s}px`,
      maxWidth: `${MARKER_LABEL_MAX_WIDTH * s}px`,
      padding: `0 ${MARKER_LABEL_PADDING_X * s}px`,
      marginBottom: `${MARKER_LABEL_MARGIN_BOTTOM * s}px`,
      fontSize: `${MARKER_LABEL_FONT_SIZE * s}px`
    },
    labelText: {
      transform: `translateY(${-MARKER_LABEL_TEXT_OFFSET_Y * s}px)`
    },
    regionLabel: {
      maxWidth: `${MARKER_LABEL_MAX_WIDTH * s}px`,
      fontSize: `${REGION_LABEL_FONT_SIZE * s}px`
    }
  }
}

/** 大屏展示固定撒点尺寸：点位宽 48px，名称框高 32px，字号 16px */
export function getFixedDisplayMarkerStyles () {
  return {
    icon: {
      width: `${MARKER_ICON_WIDTH}px`
    },
    label: {
      height: `${MARKER_LABEL_HEIGHT}px`,
      minWidth: `${MARKER_LABEL_MIN_WIDTH}px`,
      maxWidth: `${MARKER_LABEL_MAX_WIDTH}px`,
      padding: `0 ${MARKER_LABEL_PADDING_X}px`,
      marginBottom: `${MARKER_LABEL_MARGIN_BOTTOM}px`,
      fontSize: '16px'
    },
    labelText: {
      transform: `translateY(${-MARKER_LABEL_TEXT_OFFSET_Y}px)`
    },
    regionLabel: {
      maxWidth: `${MARKER_LABEL_MAX_WIDTH}px`,
      fontSize: '16px'
    }
  }
}
